const clearInput = () => {
	[ ...document.querySelectorAll( '.search-hero input[type="search"]' ) ].forEach( ( input ) => {
		const wrapper = input.closest( '.search-form' );

		if ( input.value.length !== 0 ) {
			wrapper.classList.add( 'search-form--active' );
		}

		input.addEventListener( 'input', () => {
			if ( input.value.length !== 0 ) {
				wrapper.classList.add( 'search-form--active' );
			} else {
				wrapper.classList.remove( 'search-form--active' );
			}
		} );
	} );

	[ ...document.querySelectorAll( '.search-field__clear' ) ].forEach( ( button ) => {
		const wrapper = button.closest( '.search-form' );
		const input = wrapper.querySelector( 'input[type="search"]' );
		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			input.value = '';
			wrapper.classList.remove( 'search-form--active' );
		} );
	} );
};

const blockEmptySearch = () => {
	const submitForm = document.querySelectorAll( '.search-form' );

	[ ...submitForm ].forEach( ( form ) => {
		form.addEventListener( 'submit', ( e ) => {
			const input = form.querySelector( 'input[type="search"]' );
			if ( ! input.value ) {
				e.preventDefault();
				return false;
			}
		} );
	} );
};

export { clearInput, blockEmptySearch };
